import {
  Box,
  Collapse,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react'
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMemo } from 'react'

import UserQ from '@/queries/UserQ'
import { useQuery } from '@/client/context/query'
import { SQL } from '@/client/query'
import { ONBOARDING_EXAMPLE_BIO_USERS } from '@/client/settings'

import { userDetailsFromQuery } from '@/components/Worlds/transforms/detailsFromQueries'
import Avatar from '@/components/Worlds/UI/Avatar/Avatar'
import Card from '@/components/Worlds/UI/Card'

const PROFILES_TO_SHOW = 3
const NUMBER_OF_BIO_LINES = 8

export default function BioExamples(): React.ReactElement {
  const query = useQuery()

  const numBiosToShow = useBreakpointValue({ base: 2, md: 3 })

  // TODO: Shuffle them? Causes conditional query error since we can't sync the random source
  // between SSR and browser...
  const exampleUserIds = useMemo(() => ONBOARDING_EXAMPLE_BIO_USERS.slice(0, PROFILES_TO_SHOW), [])
  const exampleUsers = query.many`${UserQ.where(
    {},
    SQL`${UserQ.id} = ANY(${exampleUserIds})`
  )}`.map(user => userDetailsFromQuery(['id', 'displayName', 'bio', 'avatarUrl'], { user }))

  const { isOpen, onToggle } = useDisclosure()
  return (
    <>
      <Box color="primary.fg" onClick={onToggle} _hover={{ cursor: 'pointer' }} mb={2}>
        <Stack direction="row" align="center" spacing={2} justifyContent="flex-end">
          {isOpen ? (
            <>
              <Box>Hide Example Bios</Box>
              <FontAwesomeIcon icon={faChevronUp} size="sm" />
            </>
          ) : (
            <>
              <Box>Show Example Bios</Box>
              <FontAwesomeIcon icon={faChevronDown} size="sm" />
            </>
          )}
        </Stack>
      </Box>
      <Collapse in={isOpen} animateOpacity>
        <Box bg="bg.subtle" rounded="md" fontSize="sm" p="16px">
          <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing="12px">
            {exampleUsers.slice(0, numBiosToShow).map(user => (
              <Card key={user.id} p="12px">
                <Stack direction="row" align="center" spacing="8px" mb="16px">
                  <Avatar user={user} size="sm" />
                  <Heading size="md">{user.displayName}</Heading>
                </Stack>
                <Text noOfLines={NUMBER_OF_BIO_LINES} variant="supporting">
                  {user.bio}
                </Text>
              </Card>
            ))}
          </SimpleGrid>
        </Box>
      </Collapse>
    </>
  )
}
